import EmailReminderSendOption from 'owa-service/lib/contract/EmailReminderSendOption';
import EmailReminderChangeType from 'owa-service/lib/contract/EmailReminderChangeType';
import type InboxReminderType from 'owa-service/lib/contract/InboxReminderType';
import type * as Schema from 'owa-graph-schema';
import { assertNever } from 'owa-assert';
import { bindTypename } from 'bind-typenames';

export function convertInboxRemindersToGql(inboxReminder: InboxReminderType): Schema.InboxReminder {
    return bindTypename(
        {
            ...inboxReminder,
            SendOption: mapEmailReminderSendOption(inboxReminder.SendOption),
            OccurrenceChange: mapEmailReminderChangeType(inboxReminder.OccurrenceChange),
        },
        'InboxReminder'
    );
}

function mapEmailReminderChangeType(
    emailReminderChangeType: EmailReminderChangeType
): Schema.EmailReminderChangeType {
    switch (emailReminderChangeType) {
        case EmailReminderChangeType.None:
            return 'None';
        case EmailReminderChangeType.Added:
            return 'Added';
        case EmailReminderChangeType.Override:
            return 'Override';
        case EmailReminderChangeType.Deleted:
            return 'Deleted';
        default:
            return assertNever(emailReminderChangeType);
    }
}

function mapEmailReminderSendOption(
    emailReminderSendOption: EmailReminderSendOption
): Schema.EmailReminderSendOption {
    switch (emailReminderSendOption) {
        case EmailReminderSendOption.NotSet:
            return 'NotSet';
        case EmailReminderSendOption.User:
            return 'User';
        case EmailReminderSendOption.AllAttendees:
            return 'AllAttendees';
        case EmailReminderSendOption.Staff:
            return 'Staff';
        case EmailReminderSendOption.Customer:
            return 'Customer';
        default:
            return assertNever(emailReminderSendOption);
    }
}
